import AudioCubeApiCallerInstance from "../utils/AudioCubeApiCallerInstance";
import { SOUNDBOX_API_ENDPOINTS } from "../URLConstants";

export const AdminLogin = async(email, password)=>{
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.ADMIN_SIGN_IN,{
                "email": email,
                "password":password
        }
        
        )
        return response;
}

export const adminLogOut=async()=>{
    const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.ADMIN_SIGN_OUT)
    return response;
   
}

export const ForgetPasswordRequest=async(emailId)=>{
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.FORGET_PASSWORD,{        
                "email":emailId
        },
        
        )
        return response; 
}

export const ResetPassword=async(token,password)=>{
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.RESET_PASSWORD,{        
                "newPassword":password,
                "token": token,
        })
        return response; 
}

export const ValidateLoginOTP = async(email, otp)=>{
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.ADMIN_VALIDATE_LOGIN_OTP,{
                "email": email,
                "otp":otp
        })
        return response;
}


